import React, { useEffect, useState } from "react";
import { useRouteMatch, useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import {
  getPatientRadiology,
  getPatientRadiologyForpagination,
} from "../../../store/actions";
import FirstView from "../Repeated-Component/FirstView";
import Pagination from "../../Pagination";
import Mri from "./../../../assets/MRI.png";

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
const RadiologyChild = ({
  getPatientRadiology,
  RadiologyList,
  getPatientRadiologyForpagination,
  history,
}) => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const params = useParams();
  const sharedToken = new URLSearchParams(location.search).get("sharedToken");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [Radiology, setRadiology] = useState([]);
  const [filterRadiology, setFilterRadiology] = useState([]);
  const [currentPage, setCuttentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const pagesNumber = Math.ceil(totalResults / 15);
  let query = useQuery().get("page");

  const nextPage = () => {
    const next = currentPage + 1;
    history.push(`${url}?page=${next}`);
  };

  const prevPage = () => {
    const prev = currentPage - 1;
    history.push(`${url}?page=${prev}`);
  };

  const specificPage = (pageNum) => {
    history.push(`${url}?page=${pageNum}`);
  };

  useEffect(() => {
    if (!query) getPatientRadiology(params.patientId, sharedToken);
  }, [getPatientRadiology, params, query, sharedToken]);

  useEffect(() => {
    if (query)
      getPatientRadiologyForpagination(query, params.patientId, sharedToken);
  }, [getPatientRadiologyForpagination, query, params, sharedToken]);

  useEffect(() => {
    const { loading, error, data } = RadiologyList;
    setLoading(loading);
    setError(error);
    if (data && data.data) {
      const list = data.data;
      setRadiology(list);
      setFilterRadiology(list);
      setTotalResults(data.meta.total);
      setCuttentPage(data.meta.current_page);
    }
  }, [RadiologyList]);
  const renderView = () => {
    return (
      <>
        <FirstView
          headerName="MRI / CT Scan"
          buttonLink={`${url}/add-radiology`}
          cardLink={`${url}/view-radiology`}
          data={Radiology}
          filterData={filterRadiology}
          setFilter={setFilterRadiology}
          loading={loading}
          error={error}
          imageForEmptyView={Mri}
          secondTitle="MRI / CT Scan"
        />
        {totalResults > 15 && filterRadiology.length > 10 ? (
          <Pagination
            pages={pagesNumber}
            nextPage={nextPage}
            prevPage={prevPage}
            specificPage={specificPage}
            currentPage={currentPage}
          />
        ) : (
          ""
        )}
      </>
    );
  };
  return renderView();
};
const mapStateToprops = (state) => {
  return {
    RadiologyList: state.RadiologyList,
  };
};
export default connect(mapStateToprops, {
  getPatientRadiology,
  getPatientRadiologyForpagination,
})(RadiologyChild);
